/* Double-submit CSRF token. */

export const CSRF_COOKIE = "trvx_csrf";
export const CSRF_HEADER = "X-CSRFToken";

export const readCsrfToken = (cookieName = CSRF_COOKIE) => {
  if (typeof document === "undefined") return null;

  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${cookieName}=`));

  if (!match) return null;

  try {
    return decodeURIComponent(match.slice(cookieName.length + 1));
  } catch {
    return null;
  }
};

/** Headers object for a raw `fetch` that changes state. */
export const csrfHeaders = (cookieName = CSRF_COOKIE) => {
  const token = readCsrfToken(cookieName);
  return token ? { [CSRF_HEADER]: token } : {};
};

/**
 * `fetch` init for an authenticated call. Cookies carry the session, so every
 * such call needs `credentials: "include"` — a raw fetch defaults to omitting
 * them cross-origin, which is how these calls used to depend on the header.
 */
export const authFetchInit = (init = {}) => ({
  ...init,
  credentials: "include",
  headers: { ...csrfHeaders(), ...(init.headers || {}) },
});
